import React from 'react';
import { useTranslation } from 'react-i18next';
import './SortDropdown.css';

function SortDropdown({ value, onChange }) {
  const { t } = useTranslation();

  const SORT_OPTIONS = [
    { value: 'newest', label: t('search.newest') },
    { value: 'oldest', label: t('search.oldest') },
    { value: 'price_asc', label: t('search.priceLowHigh') },
    { value: 'price_desc', label: t('search.priceHighLow') },
    { value: 'relevance', label: t('search.sortBy') },
  ];
  return (
    <div className="sortDropdown">
      <label>{t('search.sortBy')}</label>
      <select
        value={value || 'newest'}
        onChange={(e) => onChange(e.target.value)}
        className="sortSelect"
      >
        {SORT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SortDropdown;
